import cx from "classnames";
import { EventCard } from "common/hovercards/EventCard";
import { TRouteCard } from "common/hovercards/TRouteCard";
import { Distance, Duration, Elevation, Speed } from "common/units";
import { Event, Trip } from "data/records";
import { isEvent, isTrip } from "lib/calendarUtils";
import { commonMetrics } from "lib/localization";
import { urls } from "lib/urls";
import _ from "lodash";
import React, { Fragment } from "react";
import styles from "./EventRow.scss";

function Noop(props) {
  return props.children;
}

function TripWrapper({ event, children }) {
  return (
    <TRouteCard
      type="trip"
      id={event.id}
      name={event.name}
      distance={event.distance}
      elevationGain={event.elevationGain}
      elevationLoss={event.elevationLoss}
      movingTime={event.movingTime}
    >
      {children}
    </TRouteCard>
  );
}

function EventWrapper({ children, ...props }) {
  return <EventCard {...props}>{children}</EventCard>;
}

const HRZones = ({ hrZones, currentUser, intl }) => {
  return (
    <Fragment>
      {_.map(hrZones, (duration, zone) => (
        <Fragment key={zone}>
          {intl.formatMessage(commonMetrics.zone)} {zone}: <Duration short value={duration} valueOnly />
          <br />
        </Fragment>
      ))}
    </Fragment>
  );
};

export class EventRow extends React.PureComponent {
  static defaultProps = {
    showHoverCard: true,
  };

  eventUrl(e) {
    if (isTrip(e)) {
      return urls.trips.show(e.id);
    } else if (isEvent(e)) {
      return urls.events.show(e.id);
    } else {
      console.warn("encountered unknown event type:", e.toJS());
    }
  }

  render() {
    const { intl, event, showHoverCard, activeFields, currentUser, accessors } = this.props;

    const itemIsTrip = isTrip(event);
    const itemIsEvent = isEvent(event);
    const excludeFromTotals = event.excludeFromTotals;

    let Wrapper = Noop;

    if (event instanceof Trip && showHoverCard) {
      Wrapper = TripWrapper;
    }

    if (event instanceof Event && showHoverCard) {
      Wrapper = EventWrapper;
    }

    const tripFields =
      itemIsTrip &&
      [
        <Fragment>
          {activeFields.has("distance") && <Distance short value={event.distance} />}
          {activeFields.has("distance") && activeFields.has("elevation") && ", "}
          {activeFields.has("elevation") && <Elevation short value={event.elevationGain} />}
        </Fragment>,
        activeFields.has("movingTime") && <Duration short value={event.movingTime} valueOnly />,
        activeFields.has("avgSpeed") && <Speed short value={event.avgSpeed} />,
        activeFields.has("avgWatts") &&
          Number.isFinite(event.avgWatts) &&
          `${Math.round(event.avgWatts)} ${intl.formatMessage(commonMetrics.watts)}`,
        activeFields.has("avgWatts") &&
          !Number.isFinite(event.avgWatts) &&
          Number.isFinite(event.avgPowerEstimated) && (
            <em>{`${Math.round(event.avgPowerEstimated)} ${intl.formatMessage(commonMetrics.wattsEst)}`}</em>
          ),
        activeFields.has("calories") &&
          Number.isFinite(event.calories) &&
          `${event.calories} ${intl.formatMessage(commonMetrics.calories)}`,
        activeFields.has("heartRate") &&
          Number.isFinite(event.avgHr) &&
          `${Math.round(event.avgHr)} ${intl.formatMessage(commonMetrics.bpm)}`,
        activeFields.has("heartRateZones") && <HRZones intl={intl} hrZones={event.hrZones} currentUser={currentUser} />,
      ].filter((f) => f);

    return (
      <Wrapper event={event} currentUser={currentUser} accessors={accessors}>
        <div
          className={cx(
            styles.EventRow,
            itemIsTrip && styles.tripRow,
            itemIsEvent && styles.eventRow,
            excludeFromTotals && styles.excludeFromTotals
          )}
        >
          <a className={styles.fields} href={this.eventUrl(event)}>
            <span className={cx(styles.field, styles.name)}>{event.name}</span>
            {tripFields &&
              tripFields.map((f, i) => (
                <span key={i} className={styles.field}>
                  {f}
                </span>
              ))}
          </a>
        </div>
      </Wrapper>
    );
  }
}
